<template>
  <div class="renewed-entry-wrap">
    <div class="renewed-entry">
      <div class="renewed-info">
        <template v-if="discount">
          <h4>购新机预估价 <small>￥</small><strong>{{ price | formatPrice | formatPriceInt }}</strong><small>{{ price | formatPrice | formatPriceFloat }}</small></h4>
          <p>含换新补贴 <small>￥</small><strong>{{ discount | formatPrice | formatPriceInt}}</strong><small>{{ discount | formatPrice | formatPriceFloat}}</small></p>
        </template>
        <template v-else>
          <h4>旧机估值，享换新惊喜</h4>
          <h6 v-if="isZY">注: 旧机回收仅支持冰箱、洗衣机、空调、彩电、冷柜品类</h6>
        </template>
      </div>
      <div class="renewed-btn" @click="goPage">{{!type ? '立即换新' : '代客换新'}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "renewedEntry",
  props: ['type', 'price', 'discount', 'isZY'],
  methods: {
    goPage(){
      if (!this.$store.getters.getLoginStatus) {
        this.$store.dispatch('doLogin')
        return
      }
      this.$emit('goPage')
    }
  }
}
</script>

<style lang="scss" scoped>

.renewed-entry-wrap{
  margin-top: .24rem;
  height: 1.32rem;
  background: url(https://statics02.ehaier.com/h5/ehaier/renewed_entry_bg_1.png) no-repeat;
  background-size: contain;
  border-radius: .16rem;
}

.renewed-entry{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.renewed-info{
  padding-left: 1.6rem;
  h4{
    font-size: .28rem;
    color: #284CA9;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    small{
      font-size: .2rem;
      color: #2D77FC;
    }
    strong{
      font-size: .28rem;
      color: #2D77FC;
    }
  }
  p{
    margin-top: .12rem;
    font-size: .24rem;
    color: #FF2E2E;
    small{
      font-size: .2rem;
    }
    strong{
      font-size: .24rem;
      font-weight: normal;
    }
  }
  h6{
    margin-top: 2px;
    max-width: 3rem;
    color: #3D5289;
    font-weight: normal;
    font-family: "PingFang SC";
    font-size: 0.2rem;
    font-style: normal;
  }
}

.renewed-btn{
  margin-right: .32rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 1.44rem;
  height: .56rem;
  border: 1px solid rgba(45,119,252,1);
  border-radius: .28rem;
  font-size: .24rem;
  color: #2D77FC;
}

</style>